import { styled } from "@mui/material/styles";
import React from "react";

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
}));

const Child = styled("div")({
  maxWidth: "50%",
});

type Props = {
  children: React.ReactNode;
};

function CenteredLayout(props: Props) {
  return (
    <Container>
      <Child>{props.children}</Child>
    </Container>
  );
}

export default CenteredLayout;
